module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/passthrough.js
// module id = 139
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/readable-stream/passthrough.js